import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import FooterWrapper from '../FooterWrapper';
import { ModalProps } from '../Modal';
import NewModal from '../NewModal';

const CustomModal = styled(NewModal)``;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow-y: auto;
`;

const BodyPage = styled.div`
  overflow-y: auto;
  padding: 36px 32px;
  overflow-y: auto;

  @media (min-width: 900px) {
    padding-top: 56px;
  }
`;

const CustomFooter = styled(FooterWrapper)<{ transparent?: boolean }>`
  ${({ transparent }) => css`
    padding: 32px;
    ${transparent &&
    css`
      box-shadow: none;
    `}
  `}
`;

type ContainerModalProps = {
  childrenFooter?: ReactNode;
  childrenFooterTransparent?: ReactNode;
  headTitle?: string;
  rightText?: string;
  onPressRightText?: () => void;
  name?: string;
} & ModalProps;

const ContainerModal: React.FC<ContainerModalProps> = ({
  children,
  visible,
  onClose,
  childrenFooter,
  headTitle,
  rightText,
  onPressRightText,
  childrenFooterTransparent,
  ...rest
}) => {
  return (
    <CustomModal
      visible={visible}
      headTitle={headTitle}
      rightText={rightText}
      onPressRightText={onPressRightText}
      onClose={onClose}
      {...rest}
    >
      <Container>
        <BodyPage>{children}</BodyPage>
        {childrenFooter && <CustomFooter>{childrenFooter}</CustomFooter>}
        {childrenFooterTransparent && <CustomFooter transparent>{childrenFooterTransparent}</CustomFooter>}
      </Container>
    </CustomModal>
  );
};

export default ContainerModal;
